module.exports = __webpack_public_path__ + "img/5.0b5b6a1f.png";